var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}}),_c('h3',[_vm._v(_vm._s(_vm.message))])],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }